import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';
import { NegotiationsResponse } from '../components/negotiations/negotiations.model';

@Injectable({
  providedIn: 'root',
})
export class NegotiationsService extends Query<NegotiationsResponse> {
  document = gql`
    query NegotiationListQuery {
      negotiations {
        _id
        user_id
        lot_id
        lot_user_id
        lot_type
        commodity
        product_type
        grade
        price_value_orig {
          __typename
          ... on CashPrice {
            amount
          }
          __typename
          ... on BasisPrice {
            month
            year
            basisPoints
            product_code
          }
        }
        currency
        volume_value_orig
        units
        ship_begin_orig
        ship_end_orig
        destination
        destination
        delivery_type
        time_frame
        additional_info
        payment_term
        origin
        container_type
        delivery_option
        createdAt
        status
        counters {
          originator_id
          volume_value
          ship_begin
          ship_end
          created_at
          price_value {
            ... on CashPrice {
              amount
            }
            ... on BasisPrice {
              month
              year
              product_code
              basisPoints
            }
          }
        }
        specifications {
          title
          value
        }
        origin
        lot_market_type
        tolerance
        packaging
        rules_to_govern
        weight_grade_to_govern
      }
    }
  `;
}
